<template>
  <Banner v-if="$route.path !== '/'"/>
  <div class="content" id="content">
    <router-view />
  </div>
</template>

<script>
import Banner from "@/components/Banner";

export default {
  name: 'App',
  data() {
    return {}
  },
  components: {
    Banner
  },
  methods: {}

}
</script>

<style lang="scss">
body,
html {
  padding: 0;
  margin: 0;
  width: 100%;
  min-height: 100%; // add this rule
  background-color: #f0f0f2;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #f0f0f2;
}

.content {
  padding-top: 40px;
}

.active-blur {
  filter: blur(2px) !important;
}
.btn {
  background-color:  #f0f0f2 !important;
  color: #343a40 !important;
}
</style>
